import { useMemo } from "react";
import { responsiveFontSizes } from "@mui/material";
import { adaptV4Theme, createTheme } from "@mui/material/styles";
import { buildDocumentThemePalette } from "pages/app/organization/settings/document/general/themeUtils";

const useDocumentLinkTheme = (documentTheme, baseTheme) =>
  useMemo(() => {
    if (!documentTheme) {
      return baseTheme;
    }

    const fallbackThemeProps = {
      primary: baseTheme.palette.primary
    };
    const themeProps = buildDocumentThemePalette(documentTheme, fallbackThemeProps);
    const themeMode = documentTheme.theme_mode ?? true;

    return responsiveFontSizes(
      createTheme(
        adaptV4Theme({
          palette: {
            mode: themeMode ? "light" : "dark",
            ...(themeMode && {
              background: {
                paper: "#f1f1f1",
                default: "#f1f1f1"
              }
            }),
            ...themeProps
          }
        })
      )
    );
  }, [baseTheme, documentTheme]);

export default useDocumentLinkTheme;
